<div class="header-container" [class.left]="position === 'normal'" [class.right]="position === 'inverse'">
	<div class="logo-containter">
		<a (click)="toggleSidebar()" href="#" class="navigation"><nb-icon icon="menu-outline"></nb-icon></a>
		<div class="back-button">
			<a (click)="back()"><nb-icon icon="arrow-ios-back-outline" class="arrow-ios"></nb-icon></a>
		</div>
		<div class="logo" (click)="goToHome()">

			<img style="width: 150px;" src="assets/images/logo.svg"/>
			<!-- <span>&nbsp;PATH</span> -->
		</div>
	</div>
<!--	 <ngx-theme-switcher></ngx-theme-switcher>-->




</div>

<div class="header-container">
	<!-- <ngx-layout-direction-switcher></ngx-layout-direction-switcher> -->
	<nb-actions size="medium" [class.right]="position === 'normal'" [class.left]="position === 'inverse'">
		<nb-action *nbIsGranted="['view', 'user']">
			<nb-user *ngIf="!!crmUser" [nbContextMenu]="userMenu" [name]="crmUser.first_name" [picture]="crmUser?.picture"></nb-user>
		</nb-action>

		<nb-action class="control-item"  [nbPopover]="templateRef" nbPopoverPlacement="bottom"
		badgeText={{notification.length}} badgeStatus="info" badgePosition="bottom right" icon="bell-outline"></nb-action>
		<ng-template #templateRef>
			<nb-card [size]="'medium'">
				<nb-card-header>{{ 'Menu.Notifications' | translation }}</nb-card-header>
					<nb-list>
						<nb-list-item *ngFor="let user of notification" style="display:initial;">
							<nb-user class="unread-notifications" [name]="user.name" [title]="user.title" badgeText="New" badgeStatus="info"  badgePosition="bottom right" (click)="this.hideNotificationsBell(); _notificationsService.goToChat(user)">
							</nb-user>
							<span class="time-notification">{{ user.time }}</span>
						</nb-list-item>
					</nb-list>
					<nb-card-footer class="text-center">
						<p class="button-notification-bell" id="button-go-to-notification" (click)="this.hideNotificationsBell(); goToNotifications()">{{ 'Menu.SeeAll' | translation }}</p>
						<p class="button-notification-bell" id="button-clear-all-notification" (click)="this.clearAllNotifications(dialog);">{{ 'Menu.Clear' | translation }}</p>
					</nb-card-footer>
			  </nb-card>

		  </ng-template>

		  <nb-action class="control-item" badgeText={{adminOmMessageUnreadCount}} badgeStatus="info" badgePosition="bottom right" icon="message-circle-outline" link="/pages/admin-om-chat"></nb-action>

		  <nb-action class="control-item" badgeText={{adminMessageUnreadCount}} badgeStatus="info" badgePosition="bottom right" icon="message-square-outline" link="/pages/admin-chat"></nb-action>

		<!--<nb-action class="control-item" icon="nb-email"></nb-action>-->
		<!--<nb-action class="control-item">-->
		<!--<nb-search type="rotate-layout" (click)="startSearch()"></nb-search>-->
		<!--</nb-action>-->
	</nb-actions>
</div>

<ng-template #dialog let-data let-ref="dialogRef">
    <nb-card>
      <nb-card-header class="font-family-secondary">{{ data.title }}</nb-card-header>
      <nb-card-body>{{ data.text }}</nb-card-body>
      <nb-card-footer id="footer-confirm-dialog">
		<button nbbutton status="success" aria-disabled="false" class="status-success appearance-filled size-medium shape-rectangle nb-transition" (click)="ref.close(); data.clear()">{{ 'Common.Yes' | translation }}</button>
		<button nbbutton status="danger" aria-disabled="false" class="status-danger appearance-filled size-medium shape-rectangle nb-transition" id="button-cancel-dialog" (click)="ref.close()">{{ 'Common.No' | translation }}</button>
      </nb-card-footer>
    </nb-card>
</ng-template>
